import dayjs from "dayjs";
import { DesplegableModel } from "../interfaces";

export const borrarObjetosDuplicados = <T extends Record<string, any>>(arrayOriginal: T[], prop: keyof T, soloPropiedad: boolean): T[] | any[] => {
  const unicos = Array.from(new Map(arrayOriginal.map((item) => [item[prop], item])).values());

  return soloPropiedad ? unicos.map((item) => item[prop]) : unicos;
};

export const ordenarArrayObjetosByDate = <T extends Record<string, any>>(arrayOriginal: T[], propDate: keyof T): T[] => {
  return arrayOriginal.sort((n1, n2) => dayjs(n1[propDate]).unix() - dayjs(n2[propDate]).unix());
};

export const ordenarArrayObjetosByNumber = <T extends Record<string, any>>(arrayOriginal: T[], prop: keyof T): T[] => {
  return arrayOriginal.sort((n1, n2) => n1[prop] - n2[prop]);
};

// Función auxiliar para obtener el timestamp unix de una fecha
const getUnixTime = (fecha: DesplegableModel | string): number => {
  return typeof fecha === "string" ? dayjs(fecha).unix() : fecha.codigo;
};

// Función consolidada para buscar índice de fecha más cercana
const obtenerIndiceFechaMasCercanaInterno = (array: Array<DesplegableModel | string>, fechaSeleccionada?: DesplegableModel | string): number => {
  if (array.length === 0) return -1;

  const fechaActual = dayjs().startOf("day");
  let indiceRetornar = -1;

  // Buscar coincidencia exacta si se proporciona fecha seleccionada
  if (fechaSeleccionada !== undefined) {
    const fechaSelUnix = getUnixTime(fechaSeleccionada);
    indiceRetornar = array.findIndex((f) => getUnixTime(f) === fechaSelUnix);
    if (indiceRetornar !== -1) return indiceRetornar;
  }

  // Buscar fecha más cercana a hoy
  indiceRetornar = array.reduce((mejorIndice, fecha, indice) => {
    const distanciaActual = Math.abs(getUnixTime(fecha) - fechaActual.unix());
    const mejorDistancia = Math.abs(getUnixTime(array[mejorIndice]) - fechaActual.unix());
    return distanciaActual < mejorDistancia ? indice : mejorIndice;
  }, 0);

  // Si la fecha encontrada es anterior a hoy y hay más fechas, avanzar al siguiente
  const fechaEncontradaUnix = getUnixTime(array[indiceRetornar]);
  if (fechaEncontradaUnix < fechaActual.unix() && indiceRetornar < array.length - 1) {
    indiceRetornar++;
  }

  return indiceRetornar;
};

// Mantener funciones públicas para retrocompatibilidad
export const obtenerIndiceArrayFechasTurnos = (array: DesplegableModel[], fechaSeleccionada?: DesplegableModel): number => {
  return obtenerIndiceFechaMasCercanaInterno(array, fechaSeleccionada);
};

export const obtenerIndiceArrayFechasTurnosString = (array: string[], fechaSeleccionada?: string): number => {
  return obtenerIndiceFechaMasCercanaInterno(array, fechaSeleccionada);
};
